import { UserGraphicsQualityPresetTypes } from '@wg/web2clientapi/browser/getClientSettings';

import { createAppSelector } from '~/store/utils/createSelector';

import type { RootState } from '~/store';

export const currentAccountSelector = (state: RootState) => state.currentAccount;

export const isLoggedInSelector = (state: RootState) => !!state.currentAccount.id;
export const isClanMemberSelector = (state: RootState) => !!state.currentAccount.clanId;
export const currentAccountIdSelector = (state: RootState) => state.currentAccount.id;
export const currentClanIdSelector = (state: RootState) => state.currentAccount.clanId;
export const currentRoleNameSelector = (state: RootState) => state.currentAccount.roleName;
export const currentAccountPermissionsSelector = (state: RootState) => state.currentAccount.permissions;
export const currentAccountActiveInvitesCountSelector = (state: RootState) => state.currentAccount.activeInvitesCount;
export const currentAccountActiveApplicationsCountSelector = (state: RootState) =>
  state.currentAccount.activeApplicationsCount;

const currentSupplyBuildingsSelector = (state: RootState) => state.currentAccount.supplyBuildings;

export const isClientGraphicsLowSelector = (state: RootState) =>
  state.currentAccount.clientSettings?.preset === UserGraphicsQualityPresetTypes.LOW;

const clanItemsSelector = (state: RootState) => state.clans.items;

export const clanItemSelector = (clanId?: number) =>
  createAppSelector(clanItemsSelector, (clanItems) => {
    if (!clanId) {
      return null;
    }
    return clanItems[clanId] || null;
  });

export const currentAccountClanIdSelector = createAppSelector(currentAccountSelector, (account) => account.clanId);

export const currentClanSelector = createAppSelector(
  currentAccountClanIdSelector,
  clanItemsSelector,
  (currentAccountClanId, clanItems) => {
    if (!currentAccountClanId) {
      return null;
    }

    return clanItems[currentAccountClanId] || null;
  },
);

export const isTreasuryBuiltSelector = createAppSelector(currentSupplyBuildingsSelector, (supplyBuildings) => {
  return supplyBuildings?.some((item) => {
    if (item && item.type === 'treasury') {
      if (item.level > 0) {
        return true;
      }
    }
    return false;
  });
});
